import React from 'react';
import { shape, node, string, bool } from 'prop-types';
import Spinner from '../../../../shared_modules/rc-spinner/rc-spinner.jsx';
import { getTrackingAttributes } from '../../utils/util';
import { getTrackingUrlParams } from '@shared_modules/custom-heap-tracking-attributes';

class ResponsiveContainer extends React.Component {
  componentDidMount() {
    this.heapTrackPageChange();
    if (window.nid) {
      window.nid('stateChange');
    }
    if (window.innerWidth <= 767) this.scrollToElem.scrollIntoView();
  }

  componentDidUpdate(prevProps) {
    if (this.props.pathname !== prevProps.pathname) {
      this.heapTrackPageChange();
      // const rect = that.scrollToElem.getBoundingClientRect();
      // window.scrollBy(0, rect.top); // method 1
      // if (window.innerWidth <= 767) window.scrollTo(0, 75); // method 2
      if (window.innerWidth <= 767) this.scrollToElem.scrollIntoView(); // method 3
    }
  }

  heapTrackPageChange = () => {
    let currStep = this.props.tracking.currentStep;
    const cookieTracking = this.props.tracking?.heapTrackingPage?.cookieTracking || {};
    currStep = currStep && currStep.slice(1); // remove '/' from beginning
    const extraTrackingProps = currStep === 'loan-type' ? { ...getTrackingUrlParams(), ...cookieTracking } : {};
    if (!window.lcTracking) return;
    window.lcTracking.trackCustomEvent({
      eventName: 'PI1-1QAAT',
      eventValue: currStep,
      ...getTrackingAttributes(this.props.tracking.loanType),
      ...extraTrackingProps,
    });
  };

  render() {
    return (
      <>
        <Spinner header="One moment" text="while we help build your loan..." show={this.props.showSpinner} />
        <div
          ref={el => {
            this.scrollToElem = el;
          }}
          className={`main-content${this.props.showSpinner ? ' hidden' : ''}`}
        >
          {this.props.children}
        </div>
      </>
    );
  }
}

ResponsiveContainer.propTypes = {
  children: node.isRequired,
  pathname: string.isRequired,
  showSpinner: bool.isRequired,
  tracking: shape({
    currentStep: string.isRequired,
    loanType: string.isRequired,
    heapTrackingPage: shape({}),
  }).isRequired,
};

ResponsiveContainer.defaultProps = {
  errors: [],
};

export default ResponsiveContainer;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');